import {APIMethod} from '@enums'

import {fetchData} from 'api/api'

import {CreditDecisionResponse, CreditDecisionData} from './types'

export const getDecisionMatrix = async (companyId?: string): Promise<CreditDecisionResponse> => {
  return fetchData({
    method: APIMethod.GET,
    url: `credit-score-matrices/${companyId}`,
  })
}

export const updateDecisionMatrix = async (body: CreditDecisionData): Promise<CreditDecisionResponse> => {
  return fetchData({
    method: APIMethod.PUT,
    url: `credit-score-matrices`,
    body,
  })
}
